import css from './TextGradient.module.scss';

export default function TextGradient({children}) {
  return (
    <span className={css.textGradient}>{children}</span>
  );
}